import PropTypes from 'prop-types';
import {useState, useEffect} from 'react';

import {getProductsFromPsrsWithCnae} from '../../services/Api';
import {checkIdFiservAlianca} from '../../services/psrAlianca';
import {checkIdiFood} from '../../services/iFoodPsr';
import {useEcStore} from '../../store/slices/ecStore';
import {usePsrStore} from '../../store/slices/psrStore';
import {CardImages} from '../CardImages';
import './AleloCards.style.scss';

export const AleloCards = (props) => {
  const primaryCnae = useEcStore((state) => state.ec.ecBasicData.primaryCnae);
  const setPsrsWithProducts = usePsrStore((state) => state.setPsrsWithProducts);
  const [aleloCardsGroup, setAleloCardsGroup] = useState([]);
  const [warning, setWarning] = useState('Buscando...');

  const showCards = () =>
    aleloCardsGroup.map((card) => (
      <CardImages key={card.id || card.name} card={card} />
    ));

  useEffect(() => {
    let psrId = checkIdiFood(props.psr.id);
    psrId = checkIdFiservAlianca(psrId);

    getProductsFromPsrsWithCnae(primaryCnae, psrId)
      .then((response) => {
        if (response.data && !response.data.length) {
          setWarning('Não encontrarmos cartões para esta maquininha.');
        }

        const filteredList = response.data.filter(
          (product) => product.isVisibleForChannel
        );

        setAleloCardsGroup(filteredList);
        setPsrsWithProducts({psr: psrId, products: response.data});
      })
      .catch(() => {
        setWarning(
          'Houve um problema ao carregar os cartões para esta maquininha.'
        );
      });
  }, [primaryCnae, props.psr.id]);

  return (
    <div className="list-cards-images" data-testid="show-card-images-in-psr">
      {!aleloCardsGroup.length && (
        <div className="list-cards-images__waring">
          <strong>{warning}</strong>
        </div>
      )}
      {!!aleloCardsGroup.length && showCards()}
    </div>
  );
};

AleloCards.propTypes = {
  psr: PropTypes.object
};
